import React from 'react';
import ReactDOM from 'react-dom';
import config from './config'
import PlayEaselJS from './PlayEaselJS';
import cloneDeep from 'lodash/cloneDeep';
import './index.css';
import payload from './files/payload.mft';

window.focus();

const images = require.context('../public/img', true); // For hidden spritesheet
let init = false;

class Muffit extends React.Component {

  constructor(props) {
    super(props);
    this.state = props.config;
    console.log(props.config);

    if(!init){
      var fileToLoad = payload;
      fetch(fileToLoad)
      .then(r => r.text())
      .then(text => {      
        this.handleFileLoaded(text);
      });      
      init = true;
    }    
  }
 
  handleUpdate(cell, value){
    const cells = cloneDeep(this.state.mapCells);
    cells[this.state.activeMap][cell] = value;
    this.setState({
      mapCells: cells
    });
  } 
  
  handleReset() {
      const cells = cloneDeep(this.state.mapCells);
      this.setState({        
        mapCells: cells
      });
  }

  handleFileLoaded(str) {
    let data = JSON.parse(str);
    let rules = cloneDeep(data.rules);          
    let spriteSheet, imgsrc, rulesImgSrc;
    
    let disabledRules = []; 
    if(data.disabledRules){
      disabledRules = data.disabledRules;
    }
    if(data.imgsrc) {
      imgsrc = data.imgsrc;
    }
    else if(data.spriteSheet) {
      spriteSheet = "./img/" + data.spriteSheet;
      imgsrc = "./img/" + data.spriteSheet;
    }
    else {
      spriteSheet = "./img/chicken.png";
      imgsrc = "./img/chicken.png";            
    }          
    
    // Map
    let cells;
    cells = cloneDeep(data.map);
    
    // Remove once all files modernised?
    let cellswide, cellshigh, cellwidth, cellheight, spriteWidth, spriteHeight, spriteSheetWidth, spriteSheetHeight, totalSprites, stageWide, stageHigh, persistent, worldWrap, timer1, timer2, bordercell, mapNames;
    if(data.cellswide){
      cellswide = Number(data.cellswide);
    } 
    else {
      cellswide = 25;//DEFAULT_CELLS_WIDE;
    }
    if(data.cellshigh){
      cellshigh = Number(data.cellshigh);
    } 
    else {
      cellshigh = 15;//DEFAULT_CELLS_HIGH;
    }
    if(data.cellwidth){
      cellwidth = Number(data.cellwidth);
    } 
    else {
      cellwidth = 32;
    }
    if(data.cellheight){
      cellheight = Number(data.cellheight);
    } 
    else {
      cellheight = 32;//DEFAULT_CELLS_HIGH;
    }
    if(data.spriteWidth){
      spriteWidth = Number(data.spriteWidth);
    } 
    else {
      spriteWidth = 32;
    }
    if(data.spriteHeight){
      spriteHeight = Number(data.spriteHeight);
    } 
    else {
      spriteHeight = 32;
    }
    if(data.spriteSheetWidth){
      spriteSheetWidth = Number(data.spriteSheetWidth);
    } 
    else {
      spriteSheetWidth = 256;
    }
    if(data.spriteSheetHeight){
      spriteSheetHeight = Number(data.spriteSheetHeight);
    } 
    else {
      spriteSheetHeight = 64;
    }
    if(data.totalSprites){
      totalSprites = Number(data.totalSprites);
    }       
    else {
      totalSprites = 16;
    }
    let spritesPerRow = Number(spriteSheetWidth) / Number(spriteWidth);
    if(data.stageWide){
      stageWide = Number(data.stageWide);
    } 
    else {
      stageWide = cellswide;//DEFAULT_CELLS_WIDE;
    }
    if(data.stageHigh){
      stageHigh = Number(data.stageHigh);
    } 
    else {
      stageHigh = cellshigh;//DEFAULT_CELLS_HIGH;
    }
    if(data.persistent){
      persistent = data.persistent;
    } else {
      persistent = false;
    }
    if(data.worldWrap){
      worldWrap = data.worldWrap;
    } else {
      worldWrap = false;
    }
    if(data.timer1){
      timer1 = Number(data.timer1);
    } 
    else {
      timer1 = 400;//DEFAULT_CELLS_WIDE;
    }
    if(data.timer2){
      timer2 = Number(data.timer2);
    }
    else {
      timer2 = 800;//DEFAULT_CELLS_WIDE;
    }
    if(data.bordercell){
      bordercell = Number(data.bordercell);
    } else {
      bordercell = 1;
    } 
    if(data.mapNames) {
      mapNames = data.mapNames;
    } else {
      mapNames = ["Map 1", "Map 2", "Map 3", "Map 4", "Map 5", "Map 6"]; // Replace with reference - To mapNames?
    }
    // Sounds
    let audio;
    if(data.audio){
      audio = cloneDeep(data.audio);
    } else {
      let audio1 = '/sounds/bump.wav';
      let audio2 = '/sounds/collide1.wav';
      let audio3 = '/sounds/pickup.wav';
      let audio4 = '/sounds/destroy2.wav';
      let audio5 = '/sounds/explode.wav';
      let audio6 = '/sounds/hit.wav';
      let audio7 = '/sounds/sand.wav';
      let audio8 = '/sounds/teleport.wav';
      let audio9 = '/sounds/completelevel.wav';
      audio = [audio1, audio2, audio3, audio4, audio5, audio6, audio7, audio8, audio9] 
    }
    let audioLabels;
    if(data.audiolabels){
      audioLabels = data.audiolabels.slice();
    } else {            
      audioLabels = ["Sound 1", "Sound 2", "Sound 3", "Sound 4", "Sound 5", "Sound 6", "Sound 7", "Sound 8", "Sound 9"];
    }

    this.setState ({            
      rules: rules,    
      disabledRules: disabledRules,  
      mapCells: cells,
      mapNames: mapNames,
      imgsrc: imgsrc,
      rulesImgSrc : rulesImgSrc,
      cellswide: cellswide,
      cellshigh: cellshigh,
      cellwidth: cellwidth,
      cellheight: cellheight,
      spriteWidth: spriteWidth,
      spriteHeight: spriteHeight,
      spriteSheetWidth: spriteSheetWidth,
      spriteSheetHeight: spriteSheetHeight,
      totalSprites: totalSprites,
      spritesPerRow: spritesPerRow,
      stageWide: stageWide,
      stageHigh: stageHigh,
      persistent: persistent,
      worldWrap: worldWrap,
      timer1: timer1,
      timer2: timer2,
      bordercell: bordercell, 
      programState: "playing",    
      audio: audio,
      audiolabels: audioLabels
    });   
}

  handleSpriteSheetLoaded(obj) {
    this.setState({
      imgsrc:obj.imgsrc,
      rulesImgSrc:obj.rulesImgSrc,
      spriteWidth: Number(obj.spriteWidth),
      spriteHeight: Number(obj.spriteHeight),
      totalSprites: Number(obj.totalSprites),    
    })
  }   

  handleChangeMap(e) {
    this.setState({ activeMap: e.target.value });
  }

  render() {
    return (
        <div>
                <PlayEaselJS
                rules={this.state.rules}
                disabledRules={this.state.disabledRules}
                cells={cloneDeep(this.state.mapCells)}
                activeMap={this.state.activeMap}
                cellswide={this.state.cellswide}
                cellshigh={this.state.cellshigh}
                stageWide={this.state.stageWide}
                stageHigh={this.state.stageHigh}
                cellwidth={this.state.cellwidth}
                cellheight={this.state.cellheight}
                persistent={this.state.persistent}
                worldWrap={this.state.worldWrap}
                timer1={this.state.timer1}
                timer2={this.state.timer2}
                bordercell={this.state.bordercell}
                spriteIndex={this.state.spriteIndex}
                spriteSheet={this.state.spriteSheet} 
                imgsrc = {this.state.imgsrc}
                spriteWidth={this.state.spriteWidth} 
                spriteHeight={this.state.spriteHeight} 
                spritesPerRow={this.state.spritesPerRow}
                totalSprites={this.state.totalSprites}
                audio={cloneDeep(this.state.audio)}
                onUpdate={(cell, value) => this.handleUpdate(cell, value)}
                />
        </div>
    );
  }
}

ReactDOM.render(
  <Muffit config={ config } />,
  document.getElementById('root')
);